module.exports = __webpack_public_path__ + "img/question15c2.5bfdd210.png";